<div style="display: flex">
    <i *ngIf="!isError" class="material-icons icon-left">check_circle_outline</i>
    <i *ngIf="isError" class="material-icons icon-left">error_outline</i>
    <span matSnackBarLabel>
        <p class="title-info"> {{titleMessage}} </p>
    </span>
    <span matSnackBarActions>
        <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
            <i class="material-icons color-icon">close</i>
        </button>
    </span>
</div>